module.exports = __webpack_public_path__ + "static/media/black-point-measure-icon.211ac34d.svg";